import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useIdleProcessValues } from '../queries/idleProcess';
import CurrentPeriodWatcherBanner from './currentPeriodWatcherBanner.component';
import { fetchPeriods } from '../store/actions';
import { currentPeriodSelector } from '../store/selectors';

const useLoadPeriods = () => {
  const dispatch = useDispatch();
  return useCallback(() => dispatch(fetchPeriods()), [dispatch]);
};

export const CurrentPeriodWatcher = () => {
  const currentPeriod = useSelector(currentPeriodSelector);

  const { data: idleProcessValues } = useIdleProcessValues();

  const loadPeriods = useLoadPeriods();

  if (!idleProcessValues.periodName || !currentPeriod?.name) {
    return null;
  }
  if (currentPeriod.name === idleProcessValues.periodName) {
    return null;
  }

  return (
    <CurrentPeriodWatcherBanner
      loadPeriods={loadPeriods}
    />
  );
};
